// Get Vue reference for instantiating
import Vue from 'vue';

// Vue.directive('tooltip', function(el, binding){
//     $(el).tooltip({
//         title: binding.value,
//         placement: binding.arg,
//         trigger: 'hover'
//     });
// });

// allow it to be updated by disposing of old tooltip fi different.
// https://stackoverflow.com/a/56976963
Vue.directive('tooltip', function(el, binding) {
  if (binding.value === binding.oldValue) {
    return
  }

  $(el).tooltip('dispose')

  let f = function (evt) {
    if (evt.target != el) {
      $(el).tooltip('hide');
    }
  };

  window.addEventListener('click', f);

  $(el).tooltip({
    title: binding.value,
    placement: binding.arg,
    trigger: 'hover click'
  });
});

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
});

Vue.directive('file-opener', {
  bind: function (el, binding) {
    if (((! binding.hasOwnProperty('value')) || binding.value) && window.IS_CORDOVA && cordova?.file) {
      console.log('Test: file opener directive installed');

      el.addEventListener('click', function (e) {
        console.log('Handling open with in app browser')

        e.preventDefault();
        e.stopPropagation();

        triggerNativeFileOpen(e.target.href || e.target.closest('[href]').href);
      });
    }
  },
  unbind: function (el, binding) {
    console.log('TODO'); // TODO
  },
});

const triggerNativeFileOpen = (fullFilePath) => {
  const filePath = cordova?.file?.cacheDirectory;
  const fileName = (fullFilePath.split('/').reverse()[0] || 'untitled')
    .replace(/[^\w\d]/g, '_');

  const handleFileOpenError = (error) => {
    console.error(error);

    alert(error);
  }

  fetch(fullFilePath)
    .then((response) => response.blob())
    .then((dataBlob) => {
      function writeFile(fileEntry, dataBlob, successFn) {
        fileEntry.createWriter(function (fileWriter) {

          fileWriter.onwriteend = function() {
            console.log("Successful file write...");

            successFn();
          };

          fileWriter.onerror = function (e) {
            console.log("Failed file write: " + e.toString());

            handleFileOpenError(e);
          };

          fileWriter.write(dataBlob);
        });
      }

      window.resolveLocalFileSystemURL(
        filePath,
        function (dirEntry) {
          dirEntry.getFile(
            fileName,
            { create: true },
            function (file) {
              writeFile(file, dataBlob, function () {
                cordova.plugins.fileOpener2.open(
                  filePath + fileName,
                  dataBlob.type,
                  {
                    error : (e) => handleFileOpenError(e),
                    success : () => console.log('File opened successfully'),
                  }
                );
              });
            }
          );
        }
      );
    })
    .catch((error) => handleFileOpenError(error));
};
